import { useEffect, useRef } from 'react';
export var useEffectOnlyOnce = function useEffectOnlyOnce(callback, dependencies, condition) {
  var calledOnce = useRef(false);
  useEffect(function () {
    if (calledOnce.current) {
      return;
    }
    if (condition !== null && condition !== void 0 && condition(dependencies)) {
      callback === null || callback === void 0 || callback(dependencies);
      calledOnce.current = true;
    }
  }, [callback, condition, dependencies]);
};